import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { jwtDecode } from "jwt-decode"; 

const OtpVerification = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (index, event) => {
    const value = event.target.value;
    if (isNaN(value)) return;

    let newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1); // Ensure only one digit
    setOtp(newOtp);

    // Move focus to next input
    if (value && index < 5) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    console.log("✅ Button Clicked! handleVerifyOtp is running");
  
    const email = localStorage.getItem("email");
    const enteredOtp = otp.join("");
    
    console.log("📩 Sending OTP:", enteredOtp); 
    console.log("📧 Stored Email:", email); // Check if email is null
    
    if (!email) {
      console.error("❌ No email found in localStorage");
      setError("Email not found. Please log in again.");
      return;
    }
  
    try {
      const response = await fetch("http://localhost:5121/api/LoginRegistration/VerifyOtp", {
      //const response = await fetch("https://apiv2.chakran.in/api/LoginRegistration/VerifyOtp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, otp: enteredOtp }),
      });
  
      console.log("🔄 Response Status:", response.status);
  
      if (!response.ok) {
        const errorData = await response.json();
        console.log("❌ API Error:", errorData);
        throw new Error(errorData.message || "OTP verification failed");
      }
  
      const data = await response.json();
      console.log("✅ OTP Verified:", data);

       // Store the auth token in localStorage
       localStorage.setItem('authToken', data.token);

        // Decode the token
        const decodedToken = jwtDecode(data.token);
        console.log("Decoded Token:", decodedToken); // Debugging
 
        // Extract RoleBaseId and store it
        localStorage.setItem("userRole", decodedToken.RoleBaseId);
        localStorage.setItem("userId", decodedToken.UserId);
  
        console.log('Login successful:', data);
  
      navigate("/dashboard");
    } catch (err) {
      console.error("❌ Error:", err.message);
      setError("Invalid OTP. Please try again.");
    }
  };
  
  const handleResendOtp = async () => {
    setError(""); // Clear error message
    const email = localStorage.getItem("email"); // Get email stored from login

    if (!email) {
        setError("Session expired. Please log in again.");
        return;
    }

    console.log("Resending OTP for:", email);

    try {
      const response = await fetch("http://localhost:5121/api/LoginRegistration/ResendOtp", {
      //  const response = await fetch("https://apiv2.chakran.in/api/LoginRegistration/ResendOtp", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email }), // Sending only email
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to resend OTP");
        }

        const data = await response.json();
        console.log("OTP Resent Successfully:", data);
        alert("A new OTP has been sent to your email.");
    } catch (err) {
        console.error("Resend OTP Error:", err.message);
        setError("Failed to resend OTP. Please try again.");
    }
  };



  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card shadow p-4 text-center" style={{ width: "400px" }}>
        <h2 className="mb-3">🔑 OTP Verification</h2>
        <p className="text-muted">Enter the 6-digit OTP sent to your email.</p>
        
        <form onSubmit={handleVerifyOtp}>
          <div className="d-flex justify-content-center mb-3">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-input-${index}`}
                type="text"
                className="form-control text-center mx-1"
                style={{ width: "50px", fontSize: "1.5rem", height: "50px" }}
                value={digit}
                onChange={(e) => handleChange(index, e)}
                maxLength="1"
              />
            ))}
          </div>
          
          {error && <small className="text-danger">{error}</small>}

          <button type="submit" className="btn btn-primary btn-block mt-3" onClick={handleVerifyOtp}>Verify OTP</button>
        </form>

        <p className="mt-3">
          Didn't receive the OTP?  
          <button className="btn btn-link p-0 text-primary" onClick={handleResendOtp}>
             Resend OTP
          </button>
        </p>
      </div>
    </div>
  );
};

export default OtpVerification;
